import * as types from "@/store/types";

const state = {
  currencies: [],
  topCurrencies: []
};

const getters = {
  [types.currencies.getters.GET_CURRENCIES]: state => {
    return state.currencies;
  },
  [types.currencies.getters.GET_TOP_CURRENCIES]: state => {
    return state.topCurrencies;
  }
};

const mutations = {
  [types.currencies.mutations.MUTATE_CURRENCIES]: (state, payload) => {
    state.currencies = payload;
  },
  [types.currencies.mutations.MUTATE_TOP_CURRENCIES]: (state, payload) => {
    state.topCurrencies = payload;
  }
};

const actions = {
  [types.currencies.actions.SET_CURRENCIES]: ({ commit }, payload) => {
    commit(types.currencies.mutations.MUTATE_CURRENCIES, payload);
  },
  [types.currencies.actions.SET_TOP_CURRENCIES]: ({ commit }, payload) => {
    commit(types.currencies.mutations.MUTATE_TOP_CURRENCIES, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
